import { Injectable } from "@angular/core";
import { EventsProvider } from "../../providers/events/events";
import { Observable } from "rxjs/Observable";

@Injectable()
export class EventosPageProvider {

    constructor(public eventProvider: EventsProvider) { }

    requestEvents(): Observable<Array<any>>{
        return this.eventProvider.solicitarEventos()
    }
}


// WEBPACK FOOTER //
// ./src/pages/eventos/eventos.provider.ts